import React from "react";
import { store, persistor } from "./store/store";
// import store from "./store/store";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { PersistGate } from "redux-persist/integration/react";
import ScrollToTop from "components/ScrollToTop/scrollToTop";

// ReactDOM.render(
//   <Provider store={store}>
//     <Router>
//       <PersistGate loading={null} persistor={persistor}>
//         <ScrollToTop />
//         <App />
//       </PersistGate>
//     </Router>
//   </Provider>,
//   document.getElementById("root")
// );

import { createRoot } from "react-dom/client";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <PersistGate loading={null} persistor={persistor}>
        <ScrollToTop />
        <App />
      </PersistGate>
    </BrowserRouter>
  </Provider>
);
